import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_CMS_ENDPOINT } from '../core/DI';
//declare let gtag: Function;

@Injectable()

export class GoogleAnalyticsService {
  enable_tracking: boolean;
  client_id: string;
  user_id: string;
  gaUrl: string;
  customerId: string;

  API_CMS_ENDPOINT: string;

  constructor(@Inject(API_CMS_ENDPOINT) apiCmsEndpoint: string, private http: HttpClient) {
    this.API_CMS_ENDPOINT = apiCmsEndpoint;
  }

  ensureInit() {
    this.customerId = sessionStorage.getItem("customerID");

    this.http.get<any>(`${this.API_CMS_ENDPOINT}/angular/setting/ga`)
      .toPromise().then(result => {
        if (result != null) {
          this.user_id = result.userId;

          let _clientId = this.GetCookie('_ga');
          if (_clientId != null)
            this.client_id = _clientId.substring(6).trim();

          this.gaUrl = `${result.gaUrl}?measurement_id=${result.measurementId}&api_secret=${result.apiSecret}`;
        }
      });
  }

  TrackSearch(searchTerm: string, url: string, isB2B: boolean = true) {
    if (searchTerm.trim() !== '') {
      let event_name = 'search_by_text';
      let searchTermlbl = 'search_term';
      let customerIdlbl = 'search_by_text_searched_by';

      this.customerId = sessionStorage.getItem("customerID");

      if (isB2B) {
        if (url.includes('search-by-vehicle')) {
          event_name = 'wheels_by_vehicle_search';
          searchTermlbl = 'wheels_by_vehicle_searched_vehicle';
          customerIdlbl = 'wheels_by_vehicle_searched_by';

          if (url.includes('wheel-search'))
            event_name = 'wheels_by_vehicle_search';
          else if (url.includes("tire-search")) {
            event_name = 'tires_by_vehicle_search';
            searchTermlbl = 'tires_by_vehicle_searched_vehicle';
            customerIdlbl = 'tires_by_vehicle_searched_by';
          }
          else if (url.includes('package-builder')) {
            if (url.includes('tires')) {
              event_name = 'tires_by_vehicle_search';
              searchTermlbl = 'tires_by_vehicle_searched_vehicle';
              customerIdlbl = 'tires_by_vehicle_searched_by';
            }
          }
        }
        else if (url.includes('search-by-specs')) {
          if (url.includes('wheels')) {
            event_name = 'wheels_by_specs_search';
            searchTermlbl = 'wheels_by_specs_searched_term';
            customerIdlbl = 'wheels_by_specs_searched_by';
          }
          else if (url.includes("tires")) {
            event_name = 'tires_by_specs_search';
            searchTermlbl = 'tires_by_specs_searched_term';
            customerIdlbl = 'tires_by_specs_searched_by';
          }
        }
        else if (url.includes('search-by-brand')) {
          if (url.includes('wheels')) {
            event_name = 'wheels_by_brand_search';
            searchTermlbl = 'wheels_by_brand_searched_term';
            customerIdlbl = 'wheels_by_brand_searched_by';
          }
          else if (url.includes("tires")) {
            event_name = 'tires_by_brand_search';
            searchTermlbl = 'tires_by_brand_searched_term';
            customerIdlbl = 'tires_by_brand_searched_by';
          }
        }
        else if (url.includes('promotions')) {
          if (url.includes('wheels')) {
            event_name = 'wheels_on_sale_search';
            searchTermlbl = 'wheels_on_sale_searched_term';
            customerIdlbl = 'wheels_on_sale_searched_by';
          }
          else if (url.includes("tires")) {
            event_name = 'tires_on_sale_search';
            searchTermlbl = 'tires_on_sale_searched_term';
            customerIdlbl = 'tires_on_sale_searched_by';
          }
          else if (url.includes("accessories")) {
            event_name = 'accessories_on_sale_search';
            searchTermlbl = 'accessories_on_sale_searched_term';
            customerIdlbl = 'accessories_on_sale_searched_by';
          }
        }
      } else { // Microsite search by wheels
        event_name = 'wheels_by_vehicle_search';
        searchTermlbl = 'wheels_by_vehicle_searched_vehicle';
        customerIdlbl = 'wheels_by_vehicle_searched_by';
      }

      let params = {};
      params = { [searchTermlbl]: searchTerm.trim() };

      if (this.customerId) {
        params = {
          [searchTermlbl]: searchTerm.trim(),
          [customerIdlbl]: this.customerId
        };
      }

      fetch(this.gaUrl, {
        method: 'POST',
        body: JSON.stringify({
          'client_id': this.client_id,
          'user_id': this.user_id,
          'events': [{
            'name': event_name,
            'params': params
          }]
        })
      });
    }
  }

  TrackRecentlySearched(searchTerm: string, url: string, isB2B: boolean = true) {
    this.customerId = sessionStorage.getItem("customerID");
    let searchedFrom = 'Package Builder';

    if (url.includes('search-by-vehicle')) {
      if (url.includes('wheel-search'))
        searchedFrom = 'Wheels by Vehicle';
      else if (url.includes("tire-search"))
        searchedFrom = 'Tires by Vehicle';
    }

    if (isB2B) {
      let params = {};
      params = { 'recently_searched_vehicle': searchTerm.trim() };

      if (this.customerId) {
        params = {
          'recently_searched_vehicle': searchTerm.trim(),
          'recently_searched_by': this.customerId,
          'searched_from': searchedFrom
        };
      }

      fetch(this.gaUrl, {
        method: 'POST',
        body: JSON.stringify({
          'client_id': this.client_id,
          'user_id': this.user_id,
          'events': [{
            'name': 'recently_searched',
            'params': params
          }]
        })
      });
    }
  }

  async TrackPageView(pageTitle: string) {
    if (pageTitle.length > 0) {
      fetch(this.gaUrl, {
        method: 'POST',
        body: JSON.stringify({
          'client_id': this.client_id,
          'user_id': this.user_id,
          'events': [{
            'name': 'page_view',
            'params': {
              'page_title': pageTitle,
            }
          }]
        })
      });
    }
  }

  TrackMicrositeSearchByWheels(searchTerm: string, url: string) {
    var arr = url.split('/').filter(element => element);
    if (arr.length >= 1) {
      const _id = this.GetCookie('_ga_' + arr[0].toLowerCase().replace('-', '') + '_id');
      const _api = this.GetCookie('_ga_' + arr[0].toLowerCase().replace('-', '') + '_api');

      if (_id !== null && _api) {
        const url = this.gaUrl.substring(0, this.gaUrl.indexOf('?'));
        this.gaUrl = `${url}?measurement_id=${_id}&api_secret=${_api}`;

        this.TrackSearch(searchTerm, url, false);
      }
    }
  }

  TrackFiltering(filterBy: string, searchTerm: string) {
    fetch(this.gaUrl, {
      method: 'POST',
      body: JSON.stringify({
        'client_id': this.client_id,
        'user_id': this.user_id,
        'events': [{
          'name': 'apply_filters',
          'params': {
            'filter_by': filterBy,
            'filter_term': searchTerm.trim()
          }
        }]
      })
    });
  }

  TrackOEMDataToggle(isToggle: boolean) {
    this.customerId = sessionStorage.getItem("customerID");

    let params = {};
    params = { 'toggle': isToggle ? 'show' : 'hide' };

    if (this.customerId) {
      params = {
        'toggle': isToggle ? 'show' : 'hide',
        'toggled_by': this.customerId
      };
    }

    fetch(this.gaUrl, {
      method: 'POST',
      body: JSON.stringify({
        'client_id': this.client_id,
        'user_id': this.user_id,
        'events': [{
          'name': 'oem_data_toggle',
          'params': params
        }]
      })
    });
  }

  GetCookie(name: string): string {
    const nameLenPlus = (name.length + 1);
    return document.cookie
      .split(';')
      .map(c => c.trim())
      .filter(cookie => {
        return cookie.substring(0, nameLenPlus) === `${name}=`;
      })
      .map(cookie => {
        return decodeURIComponent(cookie.substring(nameLenPlus));
      })[0] || null;
  }
}
